import Button from "./Button";
import solarPanelsImg from "../components/assets/solar-panals-img.avif";

const Cta = () => {
  return (
    <section 
      className="relative py-28 my-10 text-white text-center overflow-hidden bg-fixed bg-cover bg-center"
      style={{ 
        backgroundImage: `linear-gradient(rgba(2, 26, 92, 0.8), rgba(54, 32, 196, 0.8)), url('${solarPanelsImg}')`
      }}
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 bg-sparkle-pattern opacity-10"></div>
      
      {/* Floating Elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-opprimary/10 rounded-full animate-float"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/5 rounded-full animate-float-delayed"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-secondary/10 rounded-full animate-float"></div>
      
      <div 
        className="max-w-4xl mx-auto px-6 relative z-10 space-y-8"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        
        {/* Main Heading */}
        <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
          Switch to <span className="text-opprimary bg-gradient-to-r from-opprimary to-orange-400 bg-clip-text text-transparent">Clean Energy</span> Today
        </h2>
        
        {/* Description */}
        <p className="text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
          Enjoy lower electricity bills, increase your property value, and contribute to a greener planet. 
          Start your solar journey with Boost Solar and get up to <span className="text-opprimary font-semibold">30% savings</span> on your energy costs.
        </p>
        
    
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <Button 
            variant="solidorange" 
            className="transform hover:scale-105 transition-all duration-300 text-lg px-10 py-4 shadow-2xl"
            href="/solar-calculator"
          >
            <span className="flex items-center gap-3">
              Calculate Savings
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </span>
          </Button>
          
          <Button 
            className="bg-transparent text-white 
            border-2 border-white 
            hover:bg-white hover:text-primary hover:scale-105
            active:scale-95
            px-8 py-4 rounded-2xl
            shadow-lg hover:shadow-xl
            transform transition-all duration-200"
            href="/contact"
          >
            <span className="flex items-center gap-3">
              Schedule Consultation
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </span>
          </Button>
        </div>
        
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(-5deg); }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float-delayed 10s ease-in-out infinite;
        }
        .bg-sparkle-pattern {
          background-image: radial-gradient(rgba(255, 255, 255, 0.3) 1px, transparent 1px);
          background-size: 25px 25px;
        }
      `}</style>

    </section>
  );
};

export default Cta;